import React from 'react';
import { Stack } from '@mui/material';
import { SelectField, SwitchField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { BroadcastEditorModes, BroadcastFormValues } from 'modules/broadcasts/types';
import { audienceTypeOptions } from 'modules/broadcasts/constants';

interface Props {
  mode: BroadcastEditorModes;
}

export const GlobalBroadcastSettings = ({ mode }: Props) => {
  const { control } = useFormContext<BroadcastFormValues>();

  const isGlobal = useWatch({ control, name: 'isGlobal' });

  return (
    <Stack gap={2} direction="row">
      <SwitchField
        control={control}
        name="isGlobal"
        label="Create Global Broadcast"
        disabled={mode === BroadcastEditorModes.Edit}
      />
      {isGlobal && (
        <SelectField
          control={control}
          name="audienceType"
          label="Select Recipients"
          options={audienceTypeOptions}
          size="small"
          variant="outlined"
          required
        />
      )}
    </Stack>
  );
};
